import { some, sortBy } from 'lodash';
import { authoriserType } from '../config';
import ApiConstants from '../config/apiConstants';

export const authoriserMap = (authoriser) => ({
	name: authoriser.approver_name,
	id: authoriser.approver_id,
	type: authoriser.approver_type,
});

export const singleAuthoriserFilter = (authoriser) => authoriser.approver_type === authoriserType.single;
export const multiAuthoriserFilter = (authoriser) => authoriser.approver_type === authoriserType.multi;

export const getDefaultAuthoriser = (userId, status, singleAuthoriserList = [], multiAuthoriserList = []) => {
	const authoriserRequired =
		(singleAuthoriserList.length || multiAuthoriserList.length) && status.includes(ApiConstants.obligate);

	if (authoriserRequired) {
		const userCanAuthorise = singleAuthoriserList.find((authoriser) => authoriser.id === userId);

		if (userCanAuthorise) return [userCanAuthorise];

		if (singleAuthoriserList.length === 1 && multiAuthoriserList.length < 2) {
			return singleAuthoriserList;
		}

		if (multiAuthoriserList.length === 2 && singleAuthoriserList.length === 0) {
			return multiAuthoriserList;
		}
	}
	return [];
};

export const currentUserWhoCanAuthorise = (userId, approvalGroup) =>
	approvalGroup.find(
		({ approver_id, approver_type }) => approver_id === userId && approver_type === authoriserType.single
	);

export const isUserSelfApprover = (userId, authoriserList = [], idKey = 'id') =>
	some(authoriserList, (authoriser) => authoriser[idKey] === userId);
export const isUserSelfApproverMulti = (userId, authoriserList = []) =>
	some(authoriserList, (authoriser) => authoriser.id === userId && authoriser.type === authoriserType.multi);
export const isPaymentTRAObligate = (isBenIdPresent, singleAuthoriserList, status, userId) =>
	!isBenIdPresent && status === ApiConstants.obligate && isUserSelfApprover(userId, singleAuthoriserList);

export const reorderAuthoriserList = (userId, authoriserList, idKey = 'id') => {
	if (isUserSelfApprover(userId, authoriserList, idKey)) {
		return sortBy(authoriserList, [(authoriser) => (authoriser[idKey] === userId ? 0 : 1)]);
	}

	return authoriserList;
};

export const mapAuthorisersGroup = (authorisersGroup) =>
	authorisersGroup.map((authoriser) => ({
		...authoriser,
		approver_type: authoriser.approver_type.toUpperCase(),
	}));
